import { createContentfulComponent } from "frontend/contentful/lib/create-contentful-component";
import { MediaCarouselEntry } from "frontend/contentful/schema/blocks";
import { MediaCarousel } from "design-system/components/blocks/media-carousel/media-carousel";
import { createMediaCarouselProps } from "./media-carousel.props";

export interface MediaCarouselOptions {
  headerAbove?: boolean;
}

export const ContentfulMediaCarousel = createContentfulComponent<
  MediaCarouselEntry,
  MediaCarouselOptions
>(({ entry, options }) => {
  const props = createMediaCarouselProps(entry, options);

  return <MediaCarousel {...props} />;
});
